import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {CognitoIdentityProviderClient, GetUserCommand} from '@aws-sdk/client-cognito-identity-provider';
import {environment} from '../environments/environment';
import {RemindMFAComponent} from './components/remind-mfa/remind-mfa.component';
import {PortalIdpService} from './services/portal-idp.service';
import {Dialog} from '@angular/cdk/dialog';
import {HttpClient} from '@angular/common/http';
import {finalize, map, shareReplay, tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {RemindCastlabsMfaComponent} from './components/remind-castlabs-mfa/remind-castlabs-mfa.component';

@Injectable({
    providedIn: 'root'
  }
)
export class MfaGuard implements CanActivate {

  private has_mfa = false;
  private pendingCheck$: Observable<boolean> | null = null;

  constructor(
    private router: Router,
    private oAuthService: OAuthService,
    private dialog: Dialog,
    private portalIdp: PortalIdpService,
    private http: HttpClient) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.oAuthService.hasValidAccessToken()) {
      return true; // Not logged in - auth is handled by the template, not this guard
    }
    if (this.portalIdp.getIdpName() === 'Castlabs' && window.location.hostname !== 'platform.local') {
      if (this.has_mfa) {
        return true;
      }
      // Reuse in-flight request to prevent duplicate calls during rapid navigation
      if (!this.pendingCheck$) {
        this.pendingCheck$ = this.http.get(environment.castlabs_idp_api_base + '/userinfo', {
          headers: {
            Authorization: 'Bearer ' + this.oAuthService.getAccessToken()
          }
        }).pipe(
          tap(res => {
            this.has_mfa = res['mfa_enabled'];
            if (!res['mfa_enabled']) {
              this.dialog.open(RemindCastlabsMfaComponent);
            }
          }),
          map(res => res['mfa_enabled']),
          shareReplay(1),
          finalize(() => this.pendingCheck$ = null)
        );
      }
      return this.pendingCheck$;

    } else {
      return true;
    }
  }
}
